import Moment from 'moment';
import momentTz from 'moment-timezone';
import CultureInfo, { TIME_ZONE_EST } from './cultureInfo';
import AppConstants from '../constants/appConstants';
import { padStart } from 'lodash-es';
import * as XLSX from 'xlsx';
import { FULL_PERMISSION, NO_ACCESS_PERMISSION } from '../constants/Constant';
import { isIOS, isChrome, isMobile, isTablet } from 'react-device-detect';
import { AES, enc } from 'crypto-js';
import * as xlsx from 'xlsx-js-style';
import { saveAs } from 'file-saver';
import RouteConstants from '../constants/routeConstants';

export default class Helper {
    static FormatDate(value) {
        return value
            ? Moment(value).format(CultureInfo.GetCultureInfo().DateFormat)
            : '';
    }

    static FormatTime(value) {
        return value
            ? Moment(value).format(CultureInfo.GetCultureInfo().TimeFormat)
            : '';
    }

    static FormatTime24(value) {
        return value
            ? Moment(value).format(CultureInfo.GetCultureInfo().TimeFormat24)
            : '';
    }

    static FormatDayWithDate(value) {
        return value
            ? Moment(value).format(
                CultureInfo.GetCultureInfo().DayWithDateFormat
            )
            : '';
    }

    static FormatDateToLocalTimeZone(value) {
        return value
            ? Moment(value)
                .local()
                .format(CultureInfo.GetCultureInfo().DateFormat)
            : '';
    }

    static FormatDatewithoutTime(value) {
        if (!value) {
            return '';
        }
        const momentValue = Moment(value);
        if (momentValue.hours() === 0 && momentValue.minutes() === 0 && momentValue.seconds() === 0) {  
            return momentValue.format(CultureInfo.GetCultureInfo().DateFormat);
        } else {
            return momentValue.format(CultureInfo.GetCultureInfo().DateTimeFormat);
        }
    }

    static FormatDateTime(value) {
        return value
            ? Moment(value).format(CultureInfo.GetCultureInfo().DateTimeFormat)
            : '';
    }

    static FormatDateTime24(value) {
        return value
            ? Moment(value).format(
                CultureInfo.GetCultureInfo().DateTimeFormat24
            )
            : '';
    }

    static FormatDateTimeToLocalTimeZone(value) {
        return value
            ? Moment(value)
                .local()
                .format(CultureInfo.GetCultureInfo().DateTimeFormat24)
            : '';
    }

    static FormatMonthWithDate(value) {
        return value
            ? Moment(value).format(CultureInfo.GetCultureInfo().MonthDateFormat)
            : '';
    }

    static FormatMonthWithDateTime(value) {
        return value
            ? Moment(value).format(
                CultureInfo.GetCultureInfo().MonthDateTimeFormat
            )
            : '';
    }

    static FormatYearDate(value) {
        return value
            ? Moment(value).format(CultureInfo.GetCultureInfo().YearDateFormat)
            : '';
    }

    static FormatDateOnly(value) {
        return value
            ? Moment(value).format(
                CultureInfo.GetCultureInfo().YearDateFormat + `T00:00:00`
            )
            : '';
    }

    static FormatDateWithTime(value) {
        return value
            ? Moment(value).format(
                CultureInfo.GetCultureInfo().YearDateFormatWithETZ
            )
            : '';
    }

    static FormatDateWithoutYear(value) {
        return value
            ? Moment(value).format(
                CultureInfo.GetCultureInfo().DayWithoutYearFormat
            )
            : '';
    }

    static ConvertToEasternTime(value) {
        return value
            ? momentTz(value)
                .tz(TIME_ZONE_EST)
                .format(CultureInfo.GetCultureInfo().YearDateFormatWithETZ)
            : null;
    }

    static LocalMomentFromParts(date, time, offset) {
        const hours = Math.abs(Math.trunc(offset));
        const minutes = Math.abs(offset % 1) * 60;
        const utcOffset = `${offset < 0 ? '-' : '+'}${padStart(
            hours.toString(10),
            2,
            '0'
        )}:${padStart(minutes.toString(10), 2, '0')}`;
        return Moment(`${date}T${time}${utcOffset}`);
    }

    static LocalEasternTime(value) {
        const dateTimeFormat = 'YYYY-MM-DDTHH:mm:ssZ';
        const currentTZDateTime = momentTz
            .tz(value, dateTimeFormat, TIME_ZONE_EST)
            .format(dateTimeFormat);
        return currentTZDateTime;
    }

    static GetDateFileName(value) {
        return value
            ? Moment(value).format(
                CultureInfo.GetCultureInfo().DateTimeFileFormat
            )
            : '';
    }

    //... Returns a random Id string. Id length is based on the supplied length.
    static GetRandomId(length = 5) {
        var text = '';
        var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';

        for (var i = 0; i < length; i++)
            text += possible.charAt(
                Math.floor(Math.random() * possible.length)
            );

        return text;
    }

    static IfDateIsNULL(inputDate) {
        if (inputDate.indexOf('0001') > -1) {
            return true;
        } else {
            return false;
            // var minDate = Moment.utc('01/01/0001'); // minimum value as per UTC

            // var receiveDate = Moment(this.FormatDate(inputDate)); // replace with variable
            // if (Moment.utc(receiveDate).isAfter(minDate)) {
            //     return false;
            // } else {
            //     return true;
            // }
        }
    }

    static IfDateIsDefault(inputDate) {
        var minDate = Moment.utc('01/01/1900'); // minimum value as per UTC

        var receiveDate = Moment(this.FormatDate(inputDate)); // replace with variable
        if (Moment.utc(receiveDate).isAfter(minDate)) {
            return false;
        } else {
            return true;
        }
    }

    static GetNameInitials(name) {
        if (name) {
            //to remove (NBA)
            name = name.includes('(') ? name.split('(')[0] : name;
            let nameArr = name.split(',');

            if (nameArr)
                name =
                    (nameArr[1] ? nameArr[1].trim() : '') + ', ' + nameArr[0];

            var iChars = '';
            name.replace(/[a-z]{2,}/gi, function (c) {
                iChars += c.charAt(0);
            });
            return iChars.toUpperCase();
        } else return '';
    }

    /*  removeStorage: removes a key from localStorage and its sibling expiracy key
    params:
        key <string>     : localStorage key to remove
    returns:
        <boolean> : telling if operation succeeded
 */
    static removeStorage(key) {
        try {
            localStorage.removeItem(key);
            localStorage.removeItem(key + '_expiresIn');

            // window.sessionStorage.removeItem(key);
            // window.sessionStorage.removeItem(key + '_expiresIn');
        } catch (e) {
            //console.log('removeStorage: Error removing key [' + key + '] from localStorage: ' + JSON.stringify(e));
            return false;
        }
        return true;
    }
    /*  removeSessionStorage: removes a key from remove Session Storage and its sibling expiracy key
        params:
            key <string>     : remove Session Storage key to remove
        returns:
            <boolean> : telling if operation succeeded
    */
    static removeSessionStorage(key) {
        try {
            // localStorage.removeItem(key);
            // localStorage.removeItem(key + '_expiresIn');

            window.sessionStorage.removeItem(key);
            window.sessionStorage.removeItem(key + '_expiresIn');
        } catch (e) {
            //console.log('removeStorage: Error removing key [' + key + '] from localStorage: ' + JSON.stringify(e));
            return false;
        }
        return true;
    }
    /*  getStorage: retrieves a key from localStorage previously set with setStorage().
        params:
            key <string> : localStorage key
        returns:
            <string> : value of localStorage key
            null : in case of expired key or failure
     */
    static getStorage(key) {
        var now = Date.now(); //epoch time, lets deal only with integer
        // set expiration for storage
        var expiresIn = localStorage.getItem(key + '_expiresIn');

        // var expiresIn = window.sessionStorage.getItem(key + '_expiresIn');
        if (expiresIn === undefined || expiresIn === null) {
            expiresIn = 0;
        }

        if (expiresIn < now) {
            // Expired
            this.removeStorage(key);
            return null;
        } else {
            try {
                if (key == 'accessToken' || key == 'chk') {
                    var value = localStorage.getItem(key);
                    // var value = window.sessionStorage.getItem(key);

                    return JSON.parse(value);
                } else {
                    const decrypted = AES.decrypt(
                        JSON.parse(localStorage.getItem(key)),
                        process.env.REACT_APP_ENCRYPT_KEY
                    );
                    // const decrypted = AES.decrypt(
                    //     JSON.parse(window.sessionStorage.getItem(key)),
                    //     process.env.REACT_APP_ENCRYPT_KEY
                    // );

                    const decryptedString = decrypted.toString(enc.Utf8);
                    return JSON.parse(decryptedString);
                }
            } catch (e) {
                console.error(e);
                //console.log('getStorage: Error reading key [' + key + '] from localStorage: ' + JSON.stringify(e));
                return null;
            }
        }
    }
    /*  getSessionStorage: retrieves a key from Session Storage previously set with setStorage().
       params:
           key <string> : window.sessionStorage key
       returns:
           <string> : value of window.sessionStorage key
           null : in case of expired key or failure
    */
    static getSessionStorage(key) {
        var now = Date.now(); //epoch time, lets deal only with integer
        // set expiration for storage
        // var expiresIn = localStorage.getItem(key + '_expiresIn');

        var expiresIn = window.sessionStorage.getItem(key + '_expiresIn');
        if (expiresIn === undefined || expiresIn === null) {
            expiresIn = 0;
        }

        if (expiresIn < now) {
            // Expired
            this.removeSessionStorage(key);
            return null;
        } else {
            try {
                if (key == 'accessToken' || key == 'chk') {
                    // var value = localStorage.getItem(key);
                    var value = window.sessionStorage.getItem(key);

                    return JSON.parse(value);
                } else {
                    // const decrypted = AES.decrypt(
                    //     JSON.parse(localStorage.getItem(key)),
                    //     process.env.REACT_APP_ENCRYPT_KEY
                    // );
                    const decrypted = AES.decrypt(
                        JSON.parse(window.sessionStorage.getItem(key)),
                        process.env.REACT_APP_ENCRYPT_KEY
                    );

                    const decryptedString = decrypted.toString(enc.Utf8);
                    return JSON.parse(decryptedString);
                }
            } catch (e) {
                console.error(e);
                //console.log('getStorage: Error reading key [' + key + '] from localStorage: ' + JSON.stringify(e));
                return null;
            }
        }
    }
    /*  setStorage: writes a key into localStorage setting a expire time
        params:
            key <string>     : localStorage key
            value <string>   : localStorage value
            expires <number> : number of seconds from now to expire the key
        returns:
            <boolean> : telling if operation succeeded
     */
    static setStorage(key, value, expires) {
        let defaultExpiredVal = expires ? true : false;

        if (expires === undefined || expires === null) {
            expires = 24 * 60 * 60; // default: seconds for 1 day
        } else {
            expires = Math.abs(expires); //make sure it's positive
        }

        var now = Date.now(); //millisecs since epoch time, lets deal only with integer
        var schedule = now + expires * 1000;
        try {
            if (key == 'accessToken' || key == 'chk' || key == 'SSOLoginInProgress') {
                localStorage.setItem(key, JSON.stringify(value));
                localStorage.setItem(key + '_expiresIn', defaultExpiredVal ? expires : schedule);
                // window.sessionStorage.setItem(key, JSON.stringify(value));
                // window.sessionStorage.setItem(key + '_expiresIn', schedule);
            } else {
                if (typeof value == 'string') {
                    const encryptedString = AES.encrypt(
                        value,
                        process.env.REACT_APP_ENCRYPT_KEY
                    );
                    localStorage.setItem(key, JSON.stringify(encryptedString));
                    localStorage.setItem(key + '_expiresIn', schedule);

                    // window.sessionStorage.setItem(
                    //     key,
                    //     JSON.stringify(encryptedString)
                    // );
                    // window.sessionStorage.setItem(key + '_expiresIn', schedule);
                } else {
                    const encrypted = AES.encrypt(
                        JSON.stringify(value),
                        process.env.REACT_APP_ENCRYPT_KEY
                    ).toString();
                    localStorage.setItem(key, JSON.stringify(encrypted));
                    localStorage.setItem(key + '_expiresIn', schedule);

                    // window.sessionStorage.setItem(
                    //     key,
                    //     JSON.stringify(encrypted)
                    // );
                    // window.sessionStorage.setItem(key + '_expiresIn', schedule);
                }
            }
        } catch (e) {
            console.error(e);
            //console.log('setStorage: Error setting key [' + key + '] in localStorage: ' + JSON.stringify(e));
            return false;
        }
        return true;
    }
    /*  setSessionStorage: writes a key into session Storage setting a expire time
           params:
               key <string>     : setSessionStorage key
               value <string>   : setSessionStorage value
               expires <number> : number of seconds from now to expire the key
           returns:
               <boolean> : telling if operation succeeded
        */
    static setSessionStorage(key, value, expires) {
        if (expires === undefined || expires === null) {
            expires = 24 * 60 * 60; // default: seconds for 1 day
        } else {
            expires = Math.abs(expires); //make sure it's positive
        }

        var now = Date.now(); //millisecs since epoch time, lets deal only with integer
        var schedule = now + expires * 1000;
        try {
            if (key == 'accessToken' || key == 'chk') {
                // localStorage.setItem(key, JSON.stringify(value));
                // localStorage.setItem(key + '_expiresIn', schedule);
                window.sessionStorage.setItem(key, JSON.stringify(value));
                window.sessionStorage.setItem(key + '_expiresIn', schedule);
            } else {
                if (typeof value == 'string') {
                    const encryptedString = AES.encrypt(
                        value,
                        process.env.REACT_APP_ENCRYPT_KEY
                    );
                    // localStorage.setItem(key, JSON.stringify(encryptedString));
                    // localStorage.setItem(key + '_expiresIn', schedule);

                    window.sessionStorage.setItem(
                        key,
                        JSON.stringify(encryptedString)
                    );
                    window.sessionStorage.setItem(key + '_expiresIn', schedule);
                } else {
                    const encrypted = AES.encrypt(
                        JSON.stringify(value),
                        process.env.REACT_APP_ENCRYPT_KEY
                    ).toString();
                    // localStorage.setItem(key, JSON.stringify(encrypted));
                    // localStorage.setItem(key + '_expiresIn', schedule);

                    window.sessionStorage.setItem(
                        key,
                        JSON.stringify(encrypted)
                    );
                    window.sessionStorage.setItem(key + '_expiresIn', schedule);
                }
            }
        } catch (e) {
            console.error(e);
            //console.log('setStorage: Error setting key [' + key + '] in localStorage: ' + JSON.stringify(e));
            return false;
        }
        return true;
    }

    static clearLocalStorage() {
        if (localStorage) {
            let app_version = localStorage.app_version_reps;
            localStorage.clear();
            if (app_version) {
                localStorage.setItem('app_version_reps', app_version);
                window.sessionStorage.setItem('app_version_reps', app_version);
            }
        }
    }

    static descendingComparator(a, b, orderBy) {
        const varA =
            typeof a[orderBy] === 'string'
                ? a[orderBy].toUpperCase()
                : a[orderBy];
        const varB =
            typeof b[orderBy] === 'string'
                ? b[orderBy].toUpperCase()
                : b[orderBy];

        if (varB < varA) {
            return -1;
        }
        if (varB > varA) {
            return 1;
        }
        return 0;
    }

    static getComparator(order, orderBy) {
        return order === 'desc'
            ? (a, b) => this.descendingComparator(a, b, orderBy)
            : (a, b) => -this.descendingComparator(a, b, orderBy);
    }

    static stableSort(array, comparator) {
        const stabilizedThis = array.map((el, index) => [el, index]);
        stabilizedThis.sort((a, b) => {
            const order = comparator(a[0], b[0]);
            if (order !== 0) return order;
            return a[1] - b[1];
        });
        return stabilizedThis.map((el) => el[0]);
    }

    static checkUserHasPermission(user, permission) {
        return user && user.rts ? user.rts.includes(permission) : false;
    }

    static isValidREPSUser(ctx) {
        let retVal =
            ctx && ctx.user && (ctx.user.name || ctx.user.userID)
                ? true
                : false;
        return retVal;
    }

    static IsJsonString(text) {
        if (typeof text !== 'string') {
            return false;
        }
        try {
            JSON.parse(text);
            return true;
        } catch (error) {
            return false;
        }
    }

    static DayDiff(date1, date2) {
        var a = Moment(date1, 'YYYY-MM-DD');
        var b = Moment(date2, 'YYYY-MM-DD');
        var dayDiff = b.diff(a, 'days');
        return dayDiff;
    }
    static InbetweenDate(date1, date2, currentdate) {
        var startDate = Moment(date1, 'YYYY-MM-DD hh:mm:ss');
        var endDate = Moment(date2, 'YYYY-MM-DD hh:mm:ss');
        var date = Moment(currentdate, 'YYYY-MM-DD hh:mm:ss');
        return (
            date.isSame(startDate) ||
            date.isSame(endDate) ||
            date.isBetween(startDate, endDate)
        );
    }

    static compareAfterDate(date1, currentdate) {
        var startOrEndDate = Moment(date1, 'YYYY-MM-DD hh:mm:ss');
        var date = Moment(currentdate, 'YYYY-MM-DD hh:mm:ss');
        return startOrEndDate.isAfter(date);
    }

    static compareBeforeDate(date1, currentdate) {
        var startOrEndDate = Moment(date1, 'YYYY-MM-DD hh:mm:ss');
        var date = Moment(currentdate, 'YYYY-MM-DD hh:mm:ss');
        return startOrEndDate.isBefore(date);
    }

    static trimObject(obj) {
        var trimmed = JSON.stringify(obj, (key, value) => {
            if (typeof value === 'string') {
                let newValue = value.trim();
                newValue = newValue.replace(/\s+/g, ' ');
                return newValue;
            }
            return value;
        });
        return JSON.parse(trimmed);
    }
    static isAdminUser(user) {
        if (user && user.userType === AppConstants.USER_TYPES[0]) {
            return true;
        }
        return false;
    }
    static isPaymentUser(user) {
        if (user && user.userType === AppConstants.USER_TYPES[3]) {
            return true;
        }
        return false;
    }
    static isEventAdmin(user) {
        if (user && user.roles && user.roles.length > 0) {
            const eventInfo = Helper.getStorage('eventInfo');
            if (eventInfo) {
                const eventID = eventInfo.eventID;
                let findIndex = user.roles.findIndex(
                    (role) =>
                        role.eventRole === AppConstants.EVENT_ROLES[0] &&
                        role.eventID == eventID
                );
                if (findIndex > -1) return true;
                else return false;
            } else {
                return false;
            }
        }
        return false;
    }

    static isEventStaff(user) {
        if (user && user.roles && user.roles.length > 0) {
            const eventInfo = Helper.getStorage('eventInfo');
            if (eventInfo) {
                const eventID = eventInfo.eventID;
                let findIndex = user.roles.findIndex(
                    (role) =>
                        role.eventRole === AppConstants.EVENT_ROLES[1] &&
                        role.eventID == eventID
                );
                if (findIndex > -1) return true;
                else return false;
            } else {
                return false;
            }
        }
        return false;
    }
    static isEventAgent(user) {
        if (user && user.roles && user.roles.length > 0) {
            const eventInfo = Helper.getStorage('eventInfo');
            if (eventInfo) {
                const eventID = eventInfo.eventID;
                let findIndex = user.roles.findIndex(
                    (role) =>
                        role.eventRole === AppConstants.EVENT_ROLES[2] &&
                        role.eventID == eventID
                );
                if (findIndex > -1) return true;
                else return false;
            } else {
                return false;
            }
        }
        return false;
    }

    static validEmail(email) {
        var isCheckEmail = new RegExp(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,3}))$/
        );
        if (isCheckEmail.test(email)) {
            return true;
        }
        return false;
    }

    static validName(name) {
        var isCheck = new RegExp(/^[a-zA-Z ]*$/);
        if (isCheck.test(name)) {
            return true;
        }
        return false;
    }
    static validNameacceptsinglequotesanddot(name) {
        var isCheck = new RegExp(/^[a-zA-Z '._]*$/);
        if (isCheck.test(name)) {
            return true;
        }
        return false;
    }
    static validNameacceptsinglequotescommashyphenanddot(name) {
        const regex = /^[a-zA-Z ',._-]*$/;
        var isCheck = regex
        if (isCheck.test(name)) {
            return true;
        }
        return false;
    }


    static downloadReport(data, fileName) {
        if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(
                JSON.stringify(
                    window.ReactNativeWebView.postMessage(
                        JSON.stringify({
                            fileName: `${fileName}.xlsx`,
                            data: data,
                        })
                    )
                )
            );
        } else {
            if (isIOS && isChrome && (isMobile || isTablet)) {
                const worksheet = XLSX.utils.json_to_sheet(data, {
                    skipHeader: true,
                });
                const workbook = {
                    Sheets: { fileName: worksheet },
                    SheetNames: [fileName],
                };
                const excelBuffer = XLSX.write(workbook, {
                    bookType: 'xlsx',
                    type: 'array',
                });
                const EXCEL_TYPE =
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
                const finaldata = new Blob([excelBuffer], { type: EXCEL_TYPE });
                var reader = new FileReader();
                reader.readAsDataURL(finaldata);
                reader.onloadend = function () {
                    var base64data = reader.result;
                    var myWindow = window.open('', 'newWindow');
                    let a = document.createElement('a');
                    a.href = base64data;
                    a.innerHTML = 'Download File';
                    a.download = `${fileName}.xlsx`;
                    myWindow.document.body.appendChild(a);
                };
            } else {
                // let worksheet = XLSX.WorkSheet;
                let worksheet = XLSX.utils.json_to_sheet(data, {
                    skipHeader: true,
                });
                const workbook = XLSX.utils.book_new();
                const fileExtension = '.xlsx';
                const actualFileName = fileName + fileExtension;
                XLSX.utils.book_append_sheet(workbook, worksheet, fileName);
                XLSX.writeFile(workbook, actualFileName);
            }
        }
    }
    static downloadStyledReport(datas, fileName) {
        const wb = xlsx.utils.book_new();
        const data = datas;
        const sheet = xlsx.utils.json_to_sheet([{}]);
        sheet['!cols'] = [
            { wch: 15 },
            { wch: 20 },
            { wch: 20 },
            { wch: 20 },
            { wch: 20 },
            { wch: 20 },
            { wch: 15 },
            { wch: 25 },
            { wch: 30 },
            { wch: 15 },
            { wch: 25 },
            { wch: 30 },
            { wch: 15 },
            { wch: 25 },
            { wch: 30 },
            { wch: 10 },
            { wch: 20 },
            { wch: 20 },
            { wch: 20 },
        ];
        xlsx.utils.sheet_add_json(sheet, data, {
            origin: 'A1',
        });
        data.map((val, i) => {
            //  console.log(val);
            sheet['A' + (i + 1)].s = {
                alignment: {
                    horizontal: 'center',
                    vertical: 'center',
                },
            };
            sheet['B' + (i + 1)].s = {
                alignment: {
                    horizontal: 'center',
                    vertical: 'center',
                },
            };
            sheet['C' + (i + 1)].s = {
                alignment: {
                    horizontal: 'center',
                    vertical: 'center',
                },
            };
            sheet['D' + (i + 1)].s = {
                alignment: {
                    horizontal: 'center',
                    vertical: 'center',
                },
            };
            sheet['E' + (i + 1)].s = {
                alignment: {
                    horizontal: 'center',
                    vertical: 'center',
                },
            };
            sheet['F' + (i + 1)].s = {
                alignment: {
                    horizontal: 'center',
                    vertical: 'center',
                },
            };
            sheet['H' + (i + 1)].s = {
                alignment: {
                    horizontal: 'center',
                    vertical: 'center',
                    wrapText: true,
                },
            };
            sheet['I' + (i + 1)].s = {
                alignment: {
                    horizontal: 'center',
                    vertical: 'center',
                    wrapText: true,
                },
            };
            sheet['K' + (i + 1)].s = {
                alignment: {
                    horizontal: 'center',
                    vertical: 'center',
                    wrapText: true,
                },
            };
            sheet['L' + (i + 1)].s = {
                alignment: {
                    horizontal: 'center',
                    vertical: 'center',
                    wrapText: true,
                },
            };
            sheet['N' + (i + 1)].s = {
                alignment: {
                    horizontal: 'center',
                    vertical: 'center',
                    wrapText: true,
                },
            };
            sheet['O' + (i + 1)].s = {
                alignment: {
                    horizontal: 'center',
                    vertical: 'center',
                    wrapText: true,
                },
            };
            sheet['P' + (i + 1)].s = {
                alignment: {
                    horizontal: 'center',
                    vertical: 'center',
                },
            };
            sheet['Q' + (i + 1)].s = {
                alignment: {
                    horizontal: 'center',
                    vertical: 'center',
                },
            };
            sheet['R' + (i + 1)].s = {
                alignment: {
                    horizontal: 'center',
                    vertical: 'center',
                },
            };
            sheet['S' + (i + 1)].s = {
                alignment: {
                    horizontal: 'center',
                    vertical: 'center',
                },
            };
            sheet['G' + (i + 1)].s = {
                fill: {
                    fgColor: { rgb: 'B8CCE4' },
                },
                alignment: {
                    horizontal: 'center',
                    vertical: 'center',
                },
                border: {
                    bottom: { style: 'thin', color: '#ccc' },
                },
            };
            sheet['J' + (i + 1)].s = {
                fill: {
                    fgColor: { rgb: 'B8CCE4' },
                },
                alignment: {
                    horizontal: 'center',
                    vertical: 'center',
                },
                border: {
                    bottom: { style: 'thin', color: '#ccc' },
                },
            };
            sheet['M' + (i + 1)].s = {
                fill: {
                    fgColor: { rgb: 'B8CCE4' },
                },
                alignment: {
                    horizontal: 'center',
                    vertical: 'center',
                },
                border: {
                    bottom: { style: 'thin', color: '#ccc' },
                },
            };
        });
        xlsx.utils.book_append_sheet(wb, sheet);
        const eb = xlsx.write(wb, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([eb], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
        });
        saveAs(blob, fileName + '.xlsx');
    }
    static checkSameOrAfterDate(startDate, endDate) {
        var sDate = Moment(startDate, 'YYYY-MM-DD hh:mm:ss');
        var eDate = Moment(endDate, 'YYYY-MM-DD hh:mm:ss');
        return eDate.isSameOrAfter(sDate);
    }

    static getModulePermission(permissions, module) {
        const fIndex = permissions.findIndex((mod) => mod.module == module);

        if (fIndex > -1) {
            const perm = permissions[fIndex].permission;
            return perm == FULL_PERMISSION ? true : false;
        }
        return false;
    }

    static getModuleAccessPermission(permissions, module) {
        const fIndex = permissions.findIndex((mod) => mod.module == module);
        let perm = NO_ACCESS_PERMISSION;
        if (fIndex > -1) {
            perm = permissions[fIndex].permission;
        }
        return perm;
    }

    static getURLSlug() {
        let pathName = location.pathname.split('/');
        return pathName.slice(3)[0];
    }

    static getFullURLSlug() {
        let pathName = location.pathname.split('/');
        return pathName;
    }

    static CheckNumberOrString(val) {
        return val == Number(val) ? 'number' : 'string';
    }
    static isValidName(val) {
        let regex = new RegExp("^[a-zA-Z'.-]*$");
        if (regex.test(val)) {
            return true;
        }
        return false;
    }
    static hexToRGB(hex, alpha) {
        var r = parseInt(hex.slice(1, 3), 16),
            g = parseInt(hex.slice(3, 5), 16),
            b = parseInt(hex.slice(5, 7), 16);

        if (alpha) {
            return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
        } else {
            return 'rgb(' + r + ', ' + g + ', ' + b + ')';
        }
    }
    static onlyLettersAndSpaces(str) {
        return /^[A-Za-z\s]*$/.test(str);
    }
    static onlyLettersAndSpacesWithHyphens(str) {
        var isCheck = new RegExp(/^[a-zA-Z0-9-.\x27\s]+$/);
        if (isCheck.test(str)) {
            return true;
        }
        return false;
    }

    static onlyLettersAndSpacesWithHyphensAndDot(str) {
        //var isCheck = new RegExp(/^[a-zA-Z-.\x27\s]+$/);
        //with below check special character will not allow at the start of the string
        var isCheck = new RegExp(/^[a-zA-Z][,'.\-a-zA-Z\s]*$/);
        if (isCheck.test(str)) {
            return true;
        }
        return false;
    }
    static numToWords(num) {
        var a = [
            '',
            'one ',
            'two ',
            'three ',
            'four ',
            'five ',
            'six ',
            'seven ',
            'eight ',
            'nine ',
            'ten ',
            'eleven ',
            'twelve ',
            'thirteen ',
            'fourteen ',
            'fifteen ',
            'sixteen ',
            'seventeen ',
            'eighteen ',
            'nineteen ',
        ];
        var b = [
            '',
            '',
            'twenty',
            'thirty',
            'forty',
            'fifty',
            'sixty',
            'seventy',
            'eighty',
            'ninety',
        ];
        if ((num = num.toString()).length > 9) return 'overflow';
        let n = ('000000000' + num)
            .substr(-9)
            .match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
        if (!n) return;
        var str = '';
        str +=
            n[1] != 0
                ? (a[Number(n[1])] || b[n[1][0]] + ' ' + a[n[1][1]]) + 'crore '
                : '';
        str +=
            n[2] != 0
                ? (a[Number(n[2])] || b[n[2][0]] + ' ' + a[n[2][1]]) + 'lakh '
                : '';
        str +=
            n[3] != 0
                ? (a[Number(n[3])] || b[n[3][0]] + ' ' + a[n[3][1]]) +
                'thousand '
                : '';
        str +=
            n[4] != 0
                ? (a[Number(n[4])] || b[n[4][0]] + ' ' + a[n[4][1]]) +
                'hundred '
                : '';
        str +=
            n[5] != 0
                ? (str != '' ? 'and ' : '') +
                (a[Number(n[5])] || b[n[5][0]] + ' ' + a[n[5][1]])
                : '';
        return str;
    }
    static capitalize(s) {
        return s[0].toUpperCase() + s.slice(1);
    }
    static reloadPage() {
        // The last "domLoading" Time //
        var currentDocumentTimestamp =
            new Date(performance.timing.domLoading).getTime();
        // Current Time //
        var now = Date.now();
        // Ten Seconds //
        var tenSec = 10 * 1000;
        // Plus Ten Seconds //
        var plusTenSec = currentDocumentTimestamp + tenSec;
        if (now > plusTenSec) {
            window.location.reload();
        } else { }
    }
    static removeLastChars(text, n) {
        n *= -1;
        return text.slice(0, n);
    }

    static getModuleName(modules, moduleId) {
        let moduleName = '';
        if (modules && modules.length > 0) {
            let moduleInfo = modules.find(i => i.moduleID === moduleId);
            moduleName = moduleInfo ? moduleInfo.displayName : ''
        }

        if (!moduleName) {
            switch (moduleId) {
                case AppConstants.EVENT_MODULES.ALL_STAR_HOTEL:
                    moduleName = 'Player Hotel'
                    break;
                case AppConstants.EVENT_MODULES.ALL_STAR_REGISTRATION:
                    moduleName = 'All Star Registration'
                    break;
                case AppConstants.EVENT_MODULES.ALL_STAR_TICKET:
                    moduleName = 'All Star Ticket'
                    break;
                case AppConstants.EVENT_MODULES.PRIVATE_TRANSPORT:
                    moduleName = 'Private Transport'
                    break;
                case AppConstants.EVENT_MODULES.SOCIAL_RESPONSIBILITY:
                    moduleName = 'Social Impact'
                    break;
                case AppConstants.EVENT_MODULES.TRANSPORTATION:
                    moduleName = 'Flight Info'
                    break;
                case AppConstants.EVENT_MODULES.COMBINE_REGISTRATION:
                    moduleName = 'Combine Registration'
                    break;
                case AppConstants.EVENT_MODULES.INVITATION:
                    moduleName = 'Invitation'
                    break;
                case AppConstants.EVENT_MODULES.SAT_NIGHT_TRANSPORT:
                    moduleName = 'Sat Night Transportation'
                    break;
                case AppConstants.EVENT_MODULES.VIP:
                    moduleName = 'VIP'
                    break;
                case AppConstants.EVENT_MODULES.COMBINE_TRANSPORTATION:
                    moduleName = 'Combine Transportation'
                    break;
                case AppConstants.EVENT_MODULES.DRAFT_HOTEL:
                    moduleName = 'Hotel'
                    break;
                case AppConstants.EVENT_MODULES.OUTFIT:
                    moduleName = 'Outfit'
                    break;
                case AppConstants.EVENT_MODULES.CONTENT_CIRCUIT:
                    moduleName = 'Content Circuit'
                    break;
                case AppConstants.EVENT_MODULES.DRAFT_REGISTRATION:
                    moduleName = 'Draft Registration'
                    break;
                case AppConstants.EVENT_MODULES.DRAFT_TRANSPORTATION:
                    moduleName = 'Draft Transportation'
                    break;
                case AppConstants.EVENT_MODULES.DRAFT_FLIGHT_INFO:
                    moduleName = 'Draft Flight Info'
                    break;
                case AppConstants.EVENT_MODULES.DRAFT_TICKET:
                    moduleName = 'Draft Ticket'
                    break;

            }
        }

        return moduleName;
    }

    static formatPhoneNumber(phoneNumberString) {
        var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
        var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
        if (match) {
            var intlCode = (match[1] ? '+1 ' : '');
            // return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
            return [intlCode, intlCode ? ' ' : '', match[2], ' ', match[3], ' ', match[4]].join('');
        }
        return null;
    }

    static getModulePath(moduleItem) {
        let modulePath = '';
        switch (moduleItem) {
            case 'CombineRegistration':
                modulePath = RouteConstants.EVENT_REGISTER_CREATE;
                break;
            case 'AllStarRegistration':
                modulePath = RouteConstants.EVENT_ALLSTAR_REGISTER_CREATE;
                break;
            case 'DraftRegistration':
                modulePath = RouteConstants.EVENT_DRAFT_REGISTER_CREATE;
                break;
            case 'Hotel':
                modulePath = RouteConstants.EVENT_HOTEL;
                break;
            case 'DraftHotel':
                modulePath = RouteConstants.EVENT_DRAFT_HOTEL;
                break;
            case 'Credential':
                modulePath = RouteConstants.CREDENTIALS;
                break;
            case 'LunchRoom':
                modulePath = RouteConstants.LUNCHROOM;
                break;
            case 'GreenRoom':
                modulePath = RouteConstants.GREENROOM;
                break;
            case 'FlightInfo':
                modulePath = RouteConstants.COMBINE_FLIGHT_INFO;
                break;
            case 'AllStarHotel':
                modulePath = RouteConstants.EVENT_ALLSTAR_HOTEL;
                break;
            case 'Transportation':
                modulePath = RouteConstants.EVENT_TRANSIT;
                break;
            case 'DraftTransportation':
                modulePath = RouteConstants.DRAFT_EVENT_TRANSIT;
                break;
            case 'CombineTransportation':
                modulePath = RouteConstants.DRAFT_COMBINE_EVENT_TRANSIT;
                break;
            case 'Outfit':
                modulePath = RouteConstants.CREATE_OUTFIT;
                break;
            case 'VIP':
                modulePath = RouteConstants.CREATE_EVENT_VIP;
                break;
            case 'Ticket':
                modulePath = RouteConstants.CREATE_EVENT_TICKET;
                break;
            case 'SatNightTransport':
                modulePath = RouteConstants.EVENT_SAT_NIGHT_TRANSPORT_ENDUSER_CREATE;
                break;
            case 'AllStarPrivateTransport':
                modulePath = RouteConstants.PRIVATE_VEHICLE_ENDUSER_CREATE;
                break;
            case 'SocialResponsibility':
                modulePath = RouteConstants.SOCIAL_RESPONSIBILITY;
                break;
            case 'AllStarTicket':
                modulePath = RouteConstants.All_STAR_END_USER_TIKCETS;
                break;
            case 'DraftFlightInfo':
                modulePath = RouteConstants.DRAFT_FLIGHT_INFO_LIST;
                break;
            default:
                modulePath = moduleItem.toLowerCase();
                break;

        }
        return modulePath;
    }

    static isValidPhoneNumber = (phone) => {
        let regex = /^(\+?\d{1,3}[- ]?)?\d{11}$/;
        if (phone)
            return regex.test(phone);
        else
            return false;
    }
}
